'use client'

import * as React from 'react'
import { Switch as SwitchPrimitive } from 'radix-ui'

import { cn } from '@/lib/utils'

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> & { thumbClassName?: string }
>(({ className, thumbClassName, ...props }, ref) => (
  <SwitchPrimitive.Root
    className={cn(
      // Square hairline track (STYLE_GUIDE.md). Checked takes the emphasis fill, the same
      // "selected" treatment as SegmentedControl, so toggles read identically in both themes.
      'peer group/switch border-foreground/25 hover:border-foreground/40 data-[state=checked]:border-emphasis data-[state=checked]:bg-emphasis inline-flex h-5 w-9 shrink-0 cursor-pointer items-center border bg-transparent p-0.5 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50',
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitive.Thumb
      className={cn(
        // The thumb springs across (a slight overshoot) and stretches while pressed.
        'bg-foreground/50 data-[state=checked]:bg-emphasis-foreground pointer-events-none block h-3.5 w-3.5 transition-[translate,width,background-color] duration-300 ease-[cubic-bezier(0.34,1.56,0.64,1)] group-active/switch:w-4.5 data-[state=checked]:translate-x-4 data-[state=checked]:group-active/switch:translate-x-3 data-[state=unchecked]:translate-x-0 motion-reduce:transition-none',
        thumbClassName
      )}
    />
  </SwitchPrimitive.Root>
))
Switch.displayName = SwitchPrimitive.Root.displayName

export { Switch }
